import { render, staticRenderFns } from "./CompareDialog.vue?vue&type=template&id=38f654d2&"
import script from "./CompareDialog.vue?vue&type=script&lang=ts&"
export * from "./CompareDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports